import { useCallback, useEffect, useState } from "react";
import { getCatalogoModemsVendidos } from "../services/reqSolicitudes";

// Modems en estado 'Vendido' que ya son de este mismo cliente (propiedad/
// cod_servicio del modem, ver getCatalogoModemsVendidos en el backend) —
// candidatos a reactivar sin pasar por una OT de Venta/Activar Vendidos.
export function useCatalogoModemsVendidos({ cod, codCliente, codServicioCliente, q, page, limit, enabled = true }) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetch = useCallback(async () => {
    if (!enabled || !codCliente || !codServicioCliente) {
      setItems([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const resp = await getCatalogoModemsVendidos(cod, {
        buscar: q, page, limit, codCliente, codServicioCliente,
      });
      const arr = resp?.data?.items || [];
      const tot = resp?.data?.total || 0;
      setItems(arr);
      setTotal(tot);
    } finally {
      setLoading(false);
    }
  }, [cod, codCliente, codServicioCliente, q, page, limit, enabled]);

  useEffect(() => { fetch(); }, [fetch]);

  return { items, total, loading, refetch: fetch };
}
